import React from 'react';
import {Alert, Drawer, Spin} from 'antd';
import {ResearchReportBody} from '../../tools/research-report/components/ResearchReportBody';
import {formatReportTime, useResearchReportDetail} from './useResearchReportDetail';

interface Props {
    open: boolean;
    /** 开仓时研报 ID；为空时抽屉展示提示态 */
    reportId: number | null;
    /** 品种（研报未加载时用于抽屉标题） */
    symbol?: string;
    onClose: () => void;
}

/**
 * 结束态对冲卡片 → 研报右侧抽屉：复用研报页正文组件，与执行记录弹窗同源
 */
export const HedgeReportDrawer: React.FC<Props> = ({open, reportId, symbol, onClose}) => {
    const {detail, loading, error} = useResearchReportDetail(open, reportId);

    return (
        <Drawer
            className="hedge-report-drawer"
            placement="right"
            // 920px 阅读列 + 两侧留白；窄屏退化为 92vw 不溢出
            width="min(1240px, 92vw)"
            open={open}
            onClose={onClose}
            destroyOnClose
            title={detail
                ? `${detail.symbol} 研报 · ${formatReportTime(detail.generatedAt)}`
                : `${symbol ?? ''} 研报`.trim()}
        >
            <div className="hedge-report-modal-body">
                {loading ? <div className="hedge-report-mask"><Spin/></div> : null}
                {!loading && error ? <Alert type="warning" showIcon message={error}/> : null}
                {!loading && !error && detail ? (
                    <div className="hedge-report-embed">
                        <ResearchReportBody detail={detail}/>
                    </div>
                ) : null}
            </div>
        </Drawer>
    );
};

export default HedgeReportDrawer;
